(function(){
  function $(s,r){ return (r||document).querySelector(s); }
  var metaEl=$('#dcl-inq-variant'), sizeEl=$('#dcl-inq-size'), availEl=$('#dcl-inq-avail'),
      fitEl=$('#dcl-inq-fit'), noteEl=$('#dcl-inq-attached');
  if(!sizeEl) return;
  var PRODUCT=null;

  function money(c){ try{ return '$'+(c/100).toFixed(2); }catch(e){ return ''; } }

  function currentVariantId(){
    var u=new URLSearchParams(location.search).get('variant');
    if(u) return String(u);
    var f=document.querySelector('form[action*="/cart/add"] [name="id"]');
    if(f&&f.value) return String(f.value);
    return null;
  }

  function paint(){
    if(!PRODUCT) return;
    var id=currentVariantId();
    var v=null;
    if(id){ for(var i=0;i<PRODUCT.variants.length;i++){ if(String(PRODUCT.variants[i].id)===id){ v=PRODUCT.variants[i]; break; } } }
    if(!v&&PRODUCT.variants.length===1) v=PRODUCT.variants[0];
    if(!v){ sizeEl.value=''; availEl.value=''; if(metaEl) metaEl.textContent=''; return; }
    var label=(v.title&&v.title!=='Default Title')?v.title:'';
    sizeEl.value=label;
    var pre=v.available&&(PRODUCT.tags||[]).indexOf('pre-order')>-1;
    availEl.value=pre?'pre-order':(v.available?'in stock':'sold out');
    if(metaEl) metaEl.textContent=(label?label+' \u00b7 ':'')+money(v.price)+' \u00b7 '+(pre?'pre-order available':(v.available?'in stock':'currently sold out'));
  }

  function grabFitFinder(){
    try{
      var len=$('#lff-len'), wid=$('#lff-wid');
      if(!len||!len.value) return null;
      var unit=(document.querySelector('#lff-units .unitbtn[aria-pressed=true]')||{}).dataset;
      unit=unit?unit.u:'in';
      function chip(id){ var c=document.querySelector('#'+id+' .chip[aria-pressed=true]'); return c?c.textContent.trim():''; }
      var parts=['length '+len.value+' '+unit];
      if(wid&&wid.value) parts.push('width '+wid.value+' '+unit);
      var ins=chip('lff-instep'); if(ins) parts.push('instep '+ins);
      var arch=chip('lff-arch'); if(arch) parts.push('arch '+arch);
      var bun=chip('lff-bunion'); if(bun) parts.push('bunion '+bun);
      var rec=$('#lff-rec');
      if(rec&&rec.textContent.trim()) parts.push('tool said: '+rec.textContent.replace(/\s+/g,' ').trim());
      return parts.join(', ');
    }catch(e){ return null; }
  }

  function refreshFit(){
    var f=grabFitFinder();
    if(f){ fitEl.value=f;
      if(noteEl) noteEl.innerHTML='Your Fit Finder measurements will be attached to this message, so you do not have to type them out again.';
    } else { fitEl.value='not used'; if(noteEl) noteEl.innerHTML=''; }
  }

  try{
    fetch(location.pathname.replace(/\/$/,'').split('?')[0]+'.js')
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(j){ PRODUCT=j; paint(); })
      .catch(function(){});
  }catch(e){}

  document.addEventListener('change',function(e){
    if(e.target&&e.target.closest&&e.target.closest('form[action*="/cart/add"]')) setTimeout(paint,60);
  },true);
  window.addEventListener('popstate',paint);
  var push=history.pushState;
  history.pushState=function(){ push.apply(this,arguments); setTimeout(paint,60); };

  var form=$('#dcl-product-inquiry');
  if(form) form.addEventListener('submit',function(){ paint(); refreshFit(); });
  setInterval(refreshFit,2000);
  refreshFit();
})();
